import { createModalStore } from '@/shared/lib/modal';

export const useMobileNoticeModalStore = createModalStore();
